import React from 'react';
import { Link } from 'react-router-dom';

const ReadingListItem = ({ article }) => {
  const { subjects } = article;
  return (
    <div
      className="reading-list-item d-flex flex-column flex-md-row align-items-center p-3 mb-3 bg-white shadow-sm"
      style={{ borderRadius: 20, overflow: 'hidden' }}
    >
      {/* Cover image (left) */}
      {article.coverImg && (
        <div
          className="flex-shrink-0 mr-md-3 mb-2 mb-md-0"
          style={{
            borderRadius: 20,
            aspectRatio: '4/3',
            width: '152px',
            maxWidth: '152px',
            margin: 17,
            overflow: 'hidden',
            background: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={article.coverImg || '/assets/img/default_cover.svg'}
            alt={article.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              borderRadius: 0,
              display: 'block',
            }}
          />
        </div>
      )}
      {/* Title and subjects (center) */}
      <div className="flex-grow-1 text-center text-md-left">
        <div style={{ fontWeight: '700', fontSize: '32px', color: '#2D72B2' }}>
          {article.title}
        </div>
        <div className="d-flex align-items-center justify-content-center justify-content-md-start mt-1">
          {(subjects || []).map((subject, idx) => (
            <img
              key={subject + idx}
              src={`/assets/img/${subject}.svg`}
              alt={subject}
              style={{ width: '86px', height: '66px', marginRight: 8 }}
            />
          ))}
        </div>
      </div>
      {/* Action button (right) */}
      <div className="ml-md-auto mt-2 mt-md-0 d-flex align-items-center justify-content-center">
        <Link
          to={`/app/reading-history/article/${article._id}`}
        >
          <img
            className="readingItemBtn"
            src="/assets/img/readingItemBtn.svg"
          />
        </Link>
      </div>
    </div>
  );
};
export default ReadingListItem;
